import { render, staticRenderFns } from "./PromoBarC.vue?vue&type=template&id=3cae3adb&scoped=true&"
import script from "./PromoBarC.vue?vue&type=script&lang=js&"
export * from "./PromoBarC.vue?vue&type=script&lang=js&"
import style0 from "./PromoBarC.vue?vue&type=style&index=0&id=3cae3adb&prod&lang=css&"
import style1 from "./PromoBarC.vue?vue&type=style&index=1&id=3cae3adb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cae3adb",
  null
  
)

export default component.exports